import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import { Constant } from '../../const';
import ModuleNodeModel from "../../models/ModuleNodeModel";
import Utility from './../../utilities/Utility';
import ObjectUsedIn from"../../utilities/usedIn/ObjectsUsedIn";
export default class ArgumentSubCon extends BaseComponent {
    /**
     * Submenu view for argument definition lists (inputs)
     * @module ArgumentSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.varModel = this.isKnownModel() ? this.props.data.variable : this.initVarModel();
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
        this.nodetypename = this.props.context.props.context.props.nodeTypeName ? this.props.context.props.context.props.nodeTypeName : "";
        this.scriptConditions = (this.nodetypename === "Data Access" && this.props.context.props.context.props.config.script) ? this.getScriptConditions(this.props.context.props.context.props.config.script) : [];
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel() {
        return {
            argumentName: null,
            type: "variable",
            value: null,
            varName: null,
            id: Utility.uuid4(),
            sensitiveData: false            
        };
    }
    getScriptConditions(obj) {
        if (obj) {
            var n = obj.substring(obj.lastIndexOf("(") + 1, obj.lastIndexOf(")"));
            if (n) {
                var scriptOptions = n.split(",");
                var inputs = [];
                for (var i = 0; i < scriptOptions.length; i++) {
                    var object = {};
                    scriptOptions[i].trim();
                    object.value = (scriptOptions[i].split(":")[0]).trim();
                    object.name = (scriptOptions[i].split(":")[0]).trim();
                    inputs.push(object);
                }
                return inputs;
            }
        }
        else {
            return [];
        }
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    setConfig(key, value) {

        if (key === "varName") {
            this.varModel[key] = value;
        }
        
        if (key === "type") {
            this.forceUpdate();
        }
        if (this.props.context.props.context instanceof ModuleNodeModel) {
            document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        }

        this.varModel[key] = value;
    }
    /**
    * Get config proxy
    * @param {string} key
    * @returns {string}
    */
    getConfig(key) {
        return this.varModel[key];
    }

    isValidVar() {
        var isValidVar = false;

        const [scope, varName] = this.varModel.varName.split(".");
        if (scope === Constant.k.SCOPE_APPLICATION && window.apm.getVariable(varName)) {
            var appVariable = window.apm.getVariable(varName);
            //this.varModel.id = appVariable.id;
            this.varModel.sensitiveData = appVariable.props.config.sensitiveData;
            isValidVar = true;
        }

        if (scope === Constant.k.SCOPE_MODULE){
            let context = null;
            if(this.props.context.props.context&&this.props.context.props.context.props.context){
                context = this.props.context.props.context.props.context;
            }

            else if(this.props.context.props.context&&this.props.context.props.context.id){
                context = this.props.context.props.context;
            }

            if (context) {
                const usedIn= ObjectUsedIn.getObjectUsedIn(context.props.parentComponentID, window.apm.serialized);
                if(usedIn[0].length>0){
                    usedIn[0].forEach(m=>{
                        const module = window.apm.serialized.components.modules.find(mo=>mo.id===m);
                        if(module) {
                            const node =  module.versions[1].flow.nodes.find(n=>n.props.parentComponentID===context.props.parentComponentID)
                            if(node){
                                var modVariable = window.apm.getVariable(varName, module.id);
                                if(modVariable){
                                    this.varModel.id = modVariable.id;
                                    this.varModel.sensitiveData = modVariable.props.config.sensitiveData;
                                    isValidVar = true;
                                }
                            }
                        }
                    })
                }
            }
        }

        return isValidVar;
    }

    isValidModel() {
        return (this.varModel.argumentName !== null) &&
            (this.varModel.value || (this.varModel.varName && this.isValidVar()));
    }

    isKnownModel() {
        return this.props.data && this.props.data.variable;
    }
    getConditionOptions(name) {
        if (this.scriptConditions) {
            var cond = _.filter(this.scriptConditions, { value: name });
            if (cond.length > 0) {
                return this.scriptConditions.indexOf(cond[0]);
            }
        }
        return {};
    }
    /**
     * React render
     * @returns {XML}
     */
    render() {
        const preSelection = window.apm.knowledgeBase.getNodeInputTypeIndexFromValue(this.varModel.type);
        //const argumentSelection = window.apm.knowledgeBase.getNodeInputTypeIndexFromValue(this.varModel.argumentName);
        return (
            <div>

                {this.nodetypename !== "Data Access" && this.nodetypename !== "Module Reference" &&
                    <Input 
                        label={this.getPropLabel("argument_name")} 
                        hint={this.getPropLabel("argument_name_hint")} 
                        valRules={{ "noEmpty": true, "variableName": true }}
                        value={this.varModel.argumentName}
                        context={this} 
                        valKey={"argumentName"} 
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true} 
                    />
                }
                
                {this.nodetypename === "Module Reference" &&
                    <Input 
                        label={this.getPropLabel("argument_name")} 
                        hint={this.getPropLabel("argument_name_hint")} 
                        valRules={{ "noEmpty": true, "argumentName":true}}
                        suggestion={"variable"}
                        value={this.varModel.argumentName}
                        context={this} 
                        valKey={"argumentName"} 
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true}
                    />
                }
                
                {this.nodetypename === "Data Access" &&
                    <Dropdown 
                        wide={true} 
                        label={this.getPropLabel("argument_name")} 
                        optionName={this.getPropLabel("argument_name_hint")}
                        options={this.scriptConditions}
                        context={this} 
                        valKey={"argumentName"}
                        selection={this.getConditionOptions(this.varModel.argumentName)}
                        suppressUpdate={true} 
                    />
                }
                
                {<Dropdown 
                    wide={true} 
                    label={this.getPropLabel("input_type")} 
                    optionName={this.getPropLabel("type_opt")}
                    options={window.apm.knowledgeBase.getNodeInputTypes()}
                    context={this} 
                    valKey={"type"}
                    selection={preSelection} 
                    readOnly={this.props.context.props.readOnly}
                    suppressUpdate={true} 
                    />
                }

                {this.varModel.type === "value" &&
                    <Input 
                        label={this.getPropLabel("argument_value")} 
                        hint={this.getPropLabel("argument_value_hint")}
                        context={this} 
                        valKey={"value"} 
                        value={this.varModel.value} 
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true} 
                    />
                }

                {(this.varModel.type === "variable" || this.varModel.type === "parameter") &&
                    <Input 
                        label={this.getPropLabel("scoped_variable_name")} 
                        hint={this.getPropLabel("scoped_variable_name_hint")}
                        context={this} 
                        valKey={"varName"} 
                        value={this.varModel.varName} 
                        suggestion={"variable"} 
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true}
                    />
                }

                {(() => {
                    if (this.props.context.props.readOnly) {
                        return
                        <label>{this.getPropLabel("read_only")}</label>;

                    }
                    if (this.isValidModel()) {
                        // Display edit and delete for editing
                        return (
                            <div style={{width: "100%", display: "flex", justifyContent: "space-around"}}>
                                <div>
                                <Button
                                    icon={"icon-trash"} 
                                    tint={"warning"}
                                    callback={() => {
                                        this.props.context.remove(this.varIdx);
                                        this.varModel = this.initVarModel();
                                        this.props.domContext.removeSubmenu();
                                    }}
                                />
                                </div>
                                <div>
                                <Button 
                                    label="Save" 
                                    wide={true}
                                    callback={() => {
                                        if (this.isValidModel()) {
                                            this.props.context.update(this.varModel, this.varIdx);
                                        }
                                        this.varModel = this.initVarModel();
                                        this.props.domContext.removeSubmenu();
                                    }}
                                />
                                </div>
                            </div>
                        );
                    }

                    // not isValidModel
                    return (
                        <Button label="Add" wide={true}
                            callback={() => {
                                if (this.isValidModel()) {
                                    // Add current data model to item list
                                    this.props.context.add(this.varModel);
                                }
                                this.props.domContext.removeSubmenu();
                            }}
                        />
                    );
                })()}
            </div>
        );
    }
}
